import React, { useEffect, useState } from "react";
import GenericInvoiceTable from "../tables/GenericInvoiceTable";
import useApi from "../../hooks/useApi";
import LocationTransferConfig from "../config/LocationTransferConfig";

const LocationTransferTable = ({
  items,
  onItemsChange,
  setShowSidebar,
  // setItemInfo,
  currentLocation,
  setCurrentLocation,
  extraFields = [],
  purchaseData,
  initialRowUnitOptions,
  isOtherCostEnabled,
  setIsOtherCostEnabled,
  otherCosts = [],
  setOtherCosts,
  BASE_URL,
  COMPANY_CODE,
  DEPARTMENT_NO,
  mode,
  documentType,
  setFocusedProductCode,
  currentStockInhand,
}) => {
  const { request, loading } = useApi();
  const [salesmanList, setSalesmanList] = useState([]);


  return (
    <GenericInvoiceTable
      items={items}
      onItemsChange={onItemsChange}
      setShowSidebar={setShowSidebar}
      // setItemInfo={setItemInfo}
      currentLocation={currentLocation}
      setCurrentLocation={setCurrentLocation}
      extraFields={extraFields}
      documentData={purchaseData}
      config={LocationTransferConfig}
      initialRowUnitOptions={initialRowUnitOptions}
      showOtherCostButton={false}
      onShowOtherCost={() => setIsOtherCostEnabled?.((v) => !v)}
      isOtherCostVisible={false}
      otherCosts={otherCosts}
      setOtherCosts={setOtherCosts}
      salesmanOptions={salesmanList}
      mode={mode}
      documentType={documentType}
      setFocusedProductCode={setFocusedProductCode}
      currentStockInhand={currentStockInhand}
      
    />
  );
};

export default LocationTransferTable;
